
export default function AccountSection() {
 
 return (
      <section className="pb-16 bg-white min-h-screen">
        <div style={{ minHeight: '300px' }}>
          <div data-mariana-integrations="/account"></div>
        </div>
      </section>
  );
}
